var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJsxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 574,
    height: 295,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: 1
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 0L574 0L574 296L0 296z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 2
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 295.06L0 0L573.158 0L573.158 295.06z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 3
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 295.06L0 0L573.158 0L573.158 295.06z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 4
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 295.06L0 0L573.158 0L573.158 295.06z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 5
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 295.06L0 0L573.158 0L573.158 295.06z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333334 0 0 1.3333334 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L430.5 0L430.5 221.25L0 221.25z",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 -0.7474662 -0 221.25)",
    clipPath: "url(#1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L574 0L574 296L0 296z",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L574 0L574 296L0 296z",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L574 0L574 296L0 296z",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L574 0L574 296L0 296z",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L574 0L574 296L0 296z",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 295.06L0 0L573.158 0L573.158 295.06z",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#2)",
    d: "M243.589 106.397995C 254.15 95.519 268.756 88.354996 283.948 88.354996C 303.214 88.354996 314.638 97.953995 314.638 112.216995C 314.638 127.209 304.005 131.991 290.147 138.043L290.147 138.043L269.059 147.345C 255.38 153.18399 239.331 163.554 239.331 185.146C 239.331 207.5727 258.873 224.1113 285.548 224.1113C 302.949 224.1113 318.464 216.5751 328.775 205.92279L328.775 205.92279L318.417 194.34299C 309.516 202.5859 298.887 207.68741 285.548 207.68741C 269.084 207.68741 258.179 199.3837 258.179 186.252C 258.179 172.108 270.979 166.81999 282.48 161.958L282.48 161.958L303.403 152.903C 320.391 145.604 333.65 135.48 333.65 113.65199C 333.65 90.459 314.483 71.931 283.619 71.931C 263.014 71.931 245.098 80.338 232.267 93.724L232.267 93.724L243.589 106.397995z",
    stroke: "none",
    fill: "#778E93",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#3)",
    d: "M151.088 221.29489C 151.088 221.29489 150.917 149.11499 150.917 131.191C 150.917 108.293 140.348 99.431 140.008 99.08099L140.008 99.08099L140.008 99.08099C 127.942 86.80899 107.324 85.869995 94.4389 97.27699C 91.0858 100.246 88.0643 103.442 85.2084 106.384L85.2084 106.384L73.765 93.608C 76.0966 91.173004 77.6332 89.466 80.3764 86.72299C 90.0692 77.03 102.729 72.056 115.308 71.925C 127.886 71.795 143.384 76.507996 152.75 85.93399C 152.83 86.01399 152.909 86.093 152.988 86.17099C 153.428 86.61099 169.568 101.621994 169.647 127.991L169.647 127.991L169.647 221.29489L151.088 221.29489z",
    stroke: "none",
    fill: "#778E93",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#4)",
    d: "M447.593 131.675L437.112 143.395L426.633 131.675L374.833 73.765L395.793 73.765L437.112 119.965L478.442 73.765L499.392 73.765L447.593 131.675z",
    stroke: "none",
    fill: "#F40012",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#5)",
    d: "M477.573 221.29489L437.112 176.075L396.663 221.29489L375.703 221.29489L426.633 164.36499L437.112 152.645L447.593 164.36499L498.522 221.29489L477.573 221.29489z",
    stroke: "none",
    fill: "#F40012",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L574 0L574 296L0 296z",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L574 0L574 296L0 296z",
    stroke: "none",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsxLogo);
export default __webpack_public_path__ + "static/media/JSX_logo.9b2072f0c5ac295645ae79847fc8d3c0.svg";
export { ForwardRef as ReactComponent };